<template>
    <div>
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <i class="el-icon-lx-cascades"></i> 采购审批流程
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
  
      <div class="container">
        <el-form
          :rules="rules"
          :inline="true"
          :model="workflowCompany"
          ref="workflowCompany"
        >
          <el-form-item label="审批流程名称：" prop="workflowDefinitionName">
            <el-input
              v-model.trim="workflowCompany.workflowDefinitionName"
              maxlength="20"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <div class="tips">
            <span
              style="
                font-size: 12px;
                float: 20px;
                margin: 0 0 20px 5px;
                display: inline-block;
              "
            >
              说明：审批流程设置支持自定义审批层级节点，在每个节点中，可以设置多个审批人，其中的任何一人审批通过后即可进入下一层级审批节点。
            </span>
          </div>
          <!--表单添加-->
          <el-button type="success" @click="AddListRow('workflowCompany')"
            >添加审批节点</el-button
          >
          <TableList
            style="margin-top: 15px"
            :loading="loading"
            :table-data="tableData"
            :table-label="tableLabel"
          >
            <template v-slot:idx="idx">
              第{{ idx.scope.$index + 1 }}审批节点
            </template>
            <template v-slot:approver="approver">
              <el-col :span="18">
                <el-tooltip
                  class="item"
                  effect="light"
                  :disabled="disabledFlag(approver.scope.row.approverList)"
                  :content="approver.scope.row.approverList"
                  placement="top"
                >
                  <el-input
                    v-model="approver.scope.row.approverList"
                    style="width: 84%; margin-right: 10px"
                    :disabled="true"
                  />
                </el-tooltip>
              </el-col>
              <el-col :span="5">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-search"
                  :disabled="false"
                  @click="
                    editApprover(
                      workflowCompany.workflowDefinitionName,
                      approver.scope.row,
                      approver.scope.$index
                    )
                  "
                />
              </el-col>
            </template>
            <!-- 操作 -->
            <template v-slot:operation="tData">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(tData.scope.$index)"
                >删除审批节点</el-button
              >
            </template>
          </TableList>
        </el-form>
  
        <div style="margin-top: 20px; text-align: center">
          <el-button type="primary" @click="handleAddPurchase('workflowCompany')"
            >确定修改</el-button
          >
          <el-button type="primary" @click="handleBack()">返回</el-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { isSpace } from "../../../utils/validate";
  import TableList from "@/modules/projectA/components/common/e-table-list";
  import Api from "../../../api/company/index";
  export default {
    name: "",
    components: {
      TableList,
    },
    data () {
      const validateSpace = (rule, value, callback) => {
        if (isSpace(value)) {
          return callback(new Error("请输入非空格字符！"));
        } else if (!value) {
          return callback(new Error("请输入必填项！"));
        } else {
          return callback();
        }
      };
      return {
        input: "",
        workflowCompany: {
          workflowDefinitionName: "",
          companyName: "",
          WorkflowCompanySku: [],
          workflowDefinitionId: '',
        },
        rules: {
          workflowDefinitionName: [
            {pattern:/^[\w\u4e00-\u9fa5]+$/,message:'输入框类型：汉字，英文，数字，英文下划线。',trigger: "blur",},
            { required: true, trigger: "blur", validator: validateSpace },
          ],
        },
        loading: false,
        tableData: [],
        tableLabel: [
          {
            label: "审批节点",
            param: "orderNo",
            align: "center",
            slot: "idx",
          },
          {
            label: "审批人",
            param: "aftersalesNo",
            align: "center",
            slot: "approver",
          },
          {
            label: "操作",
            fixed: "right",
            align: "center",
            slot: "operation",
          },
        ],
        repetitionFlag: false,
        confirmWorkFlowSkusList:[]
      };
    },
    created () {
      this.getApproverList();
      if (this.$route.params.path == "editApproverEdit") {
        this.workflowCompany.workflowDefinitionName =
        this.$route.params.workflowDefinitionName;
      } else {
        this.workflowCompany.workflowDefinitionName = this.$getStore(
          "workflowDefinitionName"
        );
      }
      this.workflowCompany.workflowDefinitionId = this.$getStore("workflowDefinitionId");
    },
    mounted() {
      setTimeout(()=>{
        this.confirmWorkFlowSkusList = JSON.parse(this.$getStore("editConfirmWorkFlowSkusList"));
      },500)
    },
    methods: {
      //点击加号添加一行数据
      AddListRow (workflowCompany) {
        this.$refs[workflowCompany].validate((valid) => {
          if (valid) {
            this.tableData.push({});
            this.$setStore(
              "editWorkflowDefinitionName",
              this.workflowCompany.workflowDefinitionName
            );
            this.$setStore("editTableData", this.tableData);
          } else {
            console.log("请输入审批流程名称");
            return false;
          }
        });
      },
      disabledFlag (val) {
        if (val) {
          return false;
        } else {
          return true;
        }
      },
      handleDelete (index) {
        this.$confirm("此操作将永久删除该审批节点, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.tableData.splice(index, 1);
            this.confirmWorkFlowSkusList.splice(index,1)
            this.$setStore("editConfirmWorkFlowSkusList",this.confirmWorkFlowSkusList)
            let confirmWorkFlowSkusListAfter = [];
            this.confirmWorkFlowSkusList.length && this.confirmWorkFlowSkusList.forEach((each) => {
              let level = parseInt(each.level);
              if (level < index + 1) {
                confirmWorkFlowSkusListAfter.push(each);
              } else if (level > index + 1) {
                let eachAfter = each;
                let t = level - 1;
                eachAfter.level = t;
                confirmWorkFlowSkusListAfter.push(eachAfter);
              }
            });
            this.$setStore(
              "editConfirmWorkFlowSkusList",
              confirmWorkFlowSkusListAfter
            );
            this.$setStore("editTableData", this.tableData);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            return;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      editApprover (workflowDefinitionName, row, index) {
        this.setApproverStore(workflowDefinitionName, index);
        let obj = JSON.parse(this.$getStore("editConfirmWorkFlowSkusList"))[index];
        this.$setStore("editWorkFlowSkusList", obj);
        this.$router.push({
          name: "editApproverEdit",
          params: {
            workflowDefinitionName: workflowDefinitionName,
            index: index,
          },
        });
      },
  
      setApproverStore (workflowDefinitionName, index) {
        this.$setStore("editWorkflowDefinitionName", workflowDefinitionName);
        this.$setStore("editIndex", parseInt(index) + 1);
      },
      getApproverList () {
        let confirmWorkFlowSkusList = JSON.parse(
          this.$getStore("editConfirmWorkFlowSkusList")
        );
        let flag = 1;
        if (null != confirmWorkFlowSkusList) {
          flag = 2;
          this.tableData = this.conactData(confirmWorkFlowSkusList, flag);
          this.workflowCompany.workflowDefinitionName = this.$getStore(
            "editWorkflowDefinitionName"
          );
          return;
        }
        this.workflowCompany.workflowDefinitionName =
          this.$route.params.workflowDefinitionName;
        // this.$setStore("workflowDefinitionName",this.workflowCompany.workflowDefinitionName);
        let params = {
          workflowDefinitionId: this.$route.params.workflowDefinitionId,
        };
        this.$setStore("editWorkflowDefinitionId", params.workflowDefinitionId);
        let displayData = [];
        Api.getWorkflow(params).then((res) => {
          if (res.code == "200") {
            console.log(res.data, "table列表数据");
            displayData = res.data;
            this.tableData = this.conactData(
              displayData.workflowSkuHeadList,
              flag
            );
            let confirmWorkFlowSkusList2 = [];
            displayData.workflowSkuHeadList.forEach((each, index) => {
              let approverTableData = [];
              each.workflowCompanySkuList.forEach((t) => {
                let p = {
                  memberName: t.approverName,
                  realName: t.approverRealName,
                  mobile: t.approverContact,
                  approverContact: t.approverContact,
                  memberId: t.approverId
                };
                approverTableData.push(p);
              });
              let conParams = {
                workflowDefinitionName:
                  this.workflowCompany.workflowDefinitionName,
                level: index + 1,
                approverList: approverTableData,
              };
  
              confirmWorkFlowSkusList2.push(conParams);
            });
            this.$setStore(
              "editConfirmWorkFlowSkusList",
              confirmWorkFlowSkusList2
            );
            this.$setStore(
              "editWorkflowDefinitionName",
              this.workflowCompany.workflowDefinitionName
            );
            this.$setStore("editTableData", this.tableData);
          }
        });
      },
      handleAddPurchase (workflowCompany) {
        if (this.workflowCompany.workflowDefinitionName == "") {
          this.$refs[workflowCompany].validate((valid) => {
            if (!valid) {
              return false;
            }
          });
          return;
        }
        let dataArr = JSON.parse(this.$getStore("getWorkflowListTableData"));
        dataArr.map((item) => {
          if (
            item.workflowDefinitionName ==
            this.workflowCompany.workflowDefinitionName && Number(this.workflowCompany.workflowDefinitionId) != item.workflowDefinitionId
          ) {
            this.repetitionFlag = true;
          }
        });
        if (this.repetitionFlag) {
          this.repetitionFlag = false;
          return this.$message.warning("已存在同名称审批流程，请重新命名!");
        }
        if (this.tableData.length < 1) {
          return this.$message.warning("请先添加审批节点！");
        }
        let confirmWorkFlowSkusList = JSON.parse(
          this.$getStore("editConfirmWorkFlowSkusList")
        );
        // let tableData = JSON.parse(this.$getStore("editTableData"));
        // if (confirmWorkFlowSkusList.length != tableData.length) {
        //   this.$message({
        //     type: "info",
        //     message: "某审批节点为空，请查看！",
        //   });
        //   return;
        // }
        let params = {
          workflowDefinitionId: this.$getStore("editWorkflowDefinitionId"),
          workflowDefinitionName: this.workflowCompany.workflowDefinitionName,
          companyId: "100608",
          workflowSkus: [],
        };
  
        confirmWorkFlowSkusList.forEach((param) => {
          param.approverList.forEach((skuParam) => {
            let each = {
              approverContact: skuParam.mobile,
              approverName: skuParam.memberName,
              approverRealName: skuParam.realName,
              levelName: "第" + param.level + "审批节点",
              level: param.level,
              companyName: "",
              approverId: skuParam.memberId,
            };
            params.workflowSkus.push(each);
          });
        });
        Api.updateWorkflow(params).then((res) => {
          if (res.code == "200") {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.removeStore();
            this.goToUrl("/purchaseAudit");
          }
        });
      },
  
      handleBack () {
        this.removeStore();
        this.goToUrl("/purchaseAudit");
      },
      conactData (val, flag) {
        let displayData = [];
        val.forEach((v) => {
          let param = {
            levelName: "",
            approverList: "",
          };
  
          let t = "";
          //1:从前台编辑点进来 else:从修改审批人过来的
          if (flag == 1) {
            param.levelName = v.levelName;
            v.workflowCompanySkuList.forEach((each) => {
              t += each.approverRealName + ";";
            });
          } else {
            param.levelName = "第" + v.level + "审批节点";
            v.approverList.forEach((each) => {
              t += each.realName + ";";
            });
          }
          param.approverList = t;
          displayData.push(param);
        });
        return displayData;
      },
      goToUrl (url) {
        this.$store.state.tagsList.map((item, index) => {
          if (item.path == this.$route.path) {
            this.$store.state.tagsList.splice(index, 1);
          }
        })
        this.$router.push({ path: url });
      },
      removeStore () {
        this.$setStore("editWorkflowDefinitionName", "");
        this.$setStore("editIndex", null);
        this.$setStore("editTableData", null);
        this.$setStore("editWorkFlowSkusList", null);
        this.$setStore("editConfirmWorkFlowSkusList", null);
      },
  
    },
  };
  </script>
  
  <style scoped lang="scss">
  ::v-deep.el-form-item--small .el-form-item__error{
      width: 270px;
    }
  </style>
  